import { BaseNode, NodeBadge, shortUrl } from './BaseNode';

export function HttpNode({ data }: { data: { label: string; method?: string; url?: string; alias?: string } }) {
  return (
    <BaseNode
      type="http"
      label={data.label}
      alias={data.alias}
      badge={data.method && <NodeBadge>{data.method}</NodeBadge>}
      lines={[{ text: shortUrl(data.url), mono: true }]}
    />
  );
}
